import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=320a1f6b&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"
import style1 from "./SearchResults.vue?vue&type=style&index=1&id=320a1f6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a1f6b",
  null
  
)

export default component.exports